// extracted by css-extract-rspack-plugin
export default {"Box":"collaborator-role-drop-down-module__Box__rGBvd0U"};